<template>
	<main>
		<eia-form-group id="yes">
			<template slot="label">Yes</template>
			<eia-checkbox
				id="yes"
				type="radio"
				name="schedule1Development"
				:value="schedule1DevelopmentYes"
				@input="update">
			</eia-checkbox>
		</eia-form-group>

		<eia-form-group id="no">
			<template slot="label">No</template>
			<eia-checkbox
				type="radio"
				id="no"
				name="schedule1Development"
				:value="schedule1DevelopmentNo"
				@input="update">
			</eia-checkbox>
		</eia-form-group>
	</main>
</template>

<script>
import { mapState } from 'vuex';

export default {
	name: 'eia-stage-one',

	computed: {
		...mapState( 'stages', [ 'schedule1Development' ] ),

		schedule1DevelopmentYes() {
			return this.schedule1Development === true;
		},

		schedule1DevelopmentNo() {
			return this.schedule1Development === false;
		},

		nextButtonDisabled() {
			return typeof this.schedule1Development !== 'boolean';
		},
	},

	beforeMount(){
		this.emit();
	},

	methods: {
		update( bool, inputId ) {
			if( bool ) {
				this.$store.commit( 'stages/setSchedule1Development', inputId === 'yes' );
				this.emit();
			}
		},
		emit(){
			this.$emit( 'input', this.schedule1Development !== null );
		},
	},
};
</script>

<style lang="scss" scoped>
main {
	margin: 32px 0;
}
</style>
